export const INVOICE_STATUS_LABEL: Record<string, string> = {
  created: 'Created',
  down_payment: 'Partially Paid',
  full_payment: 'Paid',
};

export const TESTING_STATUS_LABEL: Record<string, string> = {
  pengujian: 'Pengujian',
  verifikasi: 'Verifikasi',
  draft_lhu: 'Draft LHU',
  verifikasi_lhu: 'Verifikasi LHU',
  cetak: 'Cetak',
  revisi_lhu: 'Revisi LHU',
  lhu_rilis: 'Cetak',
};

export function formatInvoiceGrandTotal(n: number): string {
  const v = Math.round(Number.isFinite(n) ? n : 0);
  return `Rp ${v.toLocaleString('id-ID', { maximumFractionDigits: 0 })}`;
}

export function formatInvoicePaidAmount(n: number | null | undefined): string {
  const v = Math.round(Number.isFinite(Number(n)) ? Number(n) : 0);
  if (v <= 0) return '—';
  return formatInvoiceGrandTotal(v);
}

export function formatInvoiceRequestDate(s?: string | null): string {
  if (!s?.trim()) return '—';
  const dayOnly = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (dayOnly) {
    const d = new Date(Number(dayOnly[1]), Number(dayOnly[2]) - 1, Number(dayOnly[3]));
    return d.toLocaleDateString('id-ID');
  }
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleDateString('id-ID');
}
